export default __webpack_public_path__ + "static/media/AntheasHouseMap.82353177.jpg";